// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalClaimSearchModel {
    static getAttributeTypeMap() {
        return MedicalClaimSearchModel.attributeTypeMap;
    }
}
MedicalClaimSearchModel.discriminator = undefined;
MedicalClaimSearchModel.additionalProperties = false;
MedicalClaimSearchModel.attributeTypeMap = [
    {
        "name": "abfEobNumbers",
        "baseName": "abfEobNumbers",
        "type": ""
    },
    {
        "name": "serviceLineNumber",
        "baseName": "serviceLineNumber",
        "type": "number"
    },
    {
        "name": "eobId",
        "baseName": "eobId",
        "type": "number"
    },
    {
        "name": "ids",
        "baseName": "ids",
        "type": ""
    },
    {
        "name": "claimGroupIds",
        "baseName": "claimGroupIds",
        "type": ""
    },
    {
        "name": "parentClaimIds",
        "baseName": "parentClaimIds",
        "type": ""
    },
    {
        "name": "memberNumbers",
        "baseName": "memberNumbers",
        "type": ""
    },
    {
        "name": "claimStatusIds",
        "baseName": "claimStatusIds",
        "type": ""
    },
    {
        "name": "paymentTypeIds",
        "baseName": "paymentTypeIds",
        "type": ""
    },
    {
        "name": "externalReferences",
        "baseName": "externalReferences",
        "type": ""
    },
    {
        "name": "isInPaymentBatch",
        "baseName": "isInPaymentBatch",
        "type": "boolean"
    },
    {
        "name": "promotionId",
        "baseName": "promotionId",
        "type": "number"
    },
    {
        "name": "requestedPaymentTypeId",
        "baseName": "requestedPaymentTypeId",
        "type": "number"
    },
    {
        "name": "processorId",
        "baseName": "processorId",
        "type": "number"
    },
    {
        "name": "conditionTypeId",
        "baseName": "conditionTypeId",
        "type": "number"
    },
    {
        "name": "conditionIsOpen",
        "baseName": "conditionIsOpen",
        "type": "boolean"
    },
];
//# sourceMappingURL=medicalClaimSearchModel.js.map